let resetContadorPaginador = function() {
    localStorage.setItem("eje_pagination", 0);
    localStorage.setItem("maxScrollY", 0);
};
export default resetContadorPaginador;
